import React from "react";

interface IMActionProps {
  id?: string,
  className?: string | boolean,
  helpText?: string,
  buttonText?: string,
  onClick?: () => void,
  icon?: React.ReactNode,
  children?: React.ReactNode,
  disabled?: boolean,
}

const MAction = ({ id, className, helpText, onClick, icon, buttonText, disabled, children }: IMActionProps) => {
    return (
      <div className={"m-action-button" + (disabled ? " disable-m-action-button" : "")} onClick={disabled ? undefined : onClick}>
        {icon && <i id={id ? id : undefined} className={`md-icon material-icons ${className}`} title={helpText}>
          {icon}
        </i>}
        {children}
        {buttonText && <p className="action-button-text">{buttonText}</p>}
      </div>
    );
};

export default MAction;